import React from "react"

// utility;
import * as AppConstants from "../../../utility/AppConstants"
import * as Utility from "../../../utility/Utility"

// componenti;
import TabTotali from "./TabTotali"
import TabGrafici from "./TabGrafici"
import { Tabs } from "@sogei/react-web-components-catalog"
function TabRegionali(props: any) {
    const items = [
        {
            title: (
                <>
                    <i className="fab fa-font-awesome-flag mr-2"></i>
                    {AppConstants.TAB_TOTALI}
                </>
            ),
            titleHeading: "h1",
            body: (
                <TabTotali
                    codIsa={props.codIsa}
                    macroarea={props.macroarea}
                    datiRegionali={props.datiRegionali}
                    anno={props.anno}
                />
            )
        },
        {
            title: (
                <>
                    <i className="fab fa-font-awesome-flag mr-2"></i>
                    {AppConstants.TAB_GRAFICI}
                </>
            ),
            titleHeading: "h1",
            body: (
                <TabGrafici
                    codIsa={props.codIsa}
                    datiRegionali={props.datiRegionali}
                    macroarea={Utility.trascodificaMacroArea(props.macroarea)}
                    anno={props.anno}
                />
            )
        }
    ]

    return (
        <div className="row">
            <div className="col-12">
                <Tabs
                    items={items}
                    isReverseType={true}
                    // onShow={(e: any) => console.log(e)}
                />
            </div>
        </div>
    )
}
export default TabRegionali
